export default [
    {
        path: '/manual-booking/search',
        name: 'manual_booking_search',
        component: () => import('@src/manual-booking/manual-booking-search.vue'),
        meta: {
            title: 'Manuelle Buchung suchen',
            role: 'ROLE_MANUAL_BOOKING',
        },
    },
    {
        path: '/manual-booking/create',
        name: 'manual_booking_create',
        component: () => import('@src/manual-booking/manual-booking.vue'),
        meta: {
            title: 'Manuelle Buchung anlegen',
            role: 'ROLE_MANUAL_BOOKING',
        },
    },
    {
        path: '/manual-booking/edit/:id',
        name: 'manual_booking_edit',
        component: () => import('@src/manual-booking/manual-booking.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Manuelle Buchung - Detail',
            role: 'ROLE_MANUAL_BOOKING',
        },
    },
];
